module.exports = __webpack_public_path__ + "static/media/red.0f48f16e.png";